<template>
  <a :href="href" :target="target" :class="{ 'pb-link': true }">
    <slot />
  </a>
</template>
<script>
export default {
  name: "PbLink",
  props: {
    href: {
      type: String,
      default: () => "#",
    },
    target: {
      type: String,
      default: () => "_blank",
    },
  },
  methods: {},
};
</script>
<style lang="scss">
@import "~styles/color";

.pb-link {
  display: inline-block;
  text-decoration: none;
  font-size: 1.4rem;
  color: $black;
  transition: all 0.3s;

  &:hover,
  &:active,
  &:visited {
    color: $gray;
  }
}
</style>
